<script lang="ts">
  /**
   * Wrapper around 'OpeningHours' so that the latter can deal with the opening_hours object directly
   */
  import { Store, UIEventSource } from "../../../Logic/UIEventSource"
  import type opening_hours from "opening_hours"
  import Translations from "../../i18n/Translations"
  import Loading from "../../Base/Loading.svelte"
  import Tr from "../../Base/Tr.svelte"
  import OpeningHours from "./OpeningHours.svelte"
  import { OH } from "../OpeningHours"
  import AccordionSingle from "../../Flowbite/AccordionSingle.svelte"

  export let tags: UIEventSource<Record<string, string>>
  export let opening_hours_obj: Store<opening_hours | "error">
  export let key: string

  let applicableWeek = opening_hours_obj.map((oh) => {
    if (oh === "error") {
      return "error"
    }
    try {
      return OH.createRangesForApplicableWeek(oh)
    } catch (e) {
      return e.toString()
    }
  })
</script>

{#if $tags._country === undefined}
  <Loading>
    <Tr t={Translations.t.general.opening_hours.loadingCountry} />
  </Loading>
{:else if $opening_hours_obj === undefined}
  <div class="alert">No opening hours defined with key {key}</div>
{:else if typeof $applicableWeek === "string"}
  <div class="alert" style="margin-top: 1rem">
    <Tr t={Translations.t.general.opening_hours.error_loading} />
  </div>
  {#if $applicableWeek !== "error"}
    <AccordionSingle noBorder>
      <div slot="header" class="subtle text-sm">Technical details</div>
      <div class="subtle">
        {$applicableWeek}
      </div>
    </AccordionSingle>
  {/if}
{:else}
  <OpeningHours opening_hours_obj={$opening_hours_obj} applicableWeek={$applicableWeek} />
{/if}
